import React from 'react'
import PropTypes from 'prop-types'
import Subscribe from 'src/components/subscribe'
import dennisSchmidt from 'src/images/dennis_schmidt.jpg'

const NewsletterSignUpSection = ({ conference, conferenceLocation, options }) => {
  return (
    <section>
      <div className="relative bg-gray-800">
        <div className="bg-uxdx-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
          <div className="w-full h-full bg-subscribe bg-cover">
            <div className="h-full w-full bg-community-900 bg-opacity-80">
              <div className="py-12 px-4 sm:px-12 lg:px-16 flex justify-end content-center">
                <blockquote className="mt-8 md:flex md:flex-col max-w-lg">
                  <div className="relative text-lg leading-7 font-medium text-white lg:pt-8">
                    <svg
                      className="text-community-400 absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                    >
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <p className="relative text-3xl">
                      UXDX is my favourite newsletter. Incredible content across the key areas in our
                      industry.
                    </p>
                  </div>
                  <footer className="mt-8">
                    <div className="flex">
                      <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white h-13">
                        <img className="h-12 w-12 rounded-full" src={dennisSchmidt} alt="Dennis Schmidt" />
                      </div>
                      <div className="ml-4">
                        <div className="text-base leading-6 font-medium text-white">Dennis Schmidt</div>
                        <div className="text-uxdx-100 text-base leading-6">Product Designer, COYO</div>
                      </div>
                    </div>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
        <div className="relative max-w-screen-xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div className="md:ml-auto md:w-1/2 md:pl-10 xl:pl-16">
            <div className="mb-4">
              <div className="text-4xl leading-snug font-medium text-white" id="label-newsletter-option">
                <h2>Stay up to date on the latest in Product Development</h2>
              </div>
            </div>
            <div className="mt-4 sm:max-w-md">
              <Subscribe id={conference.data.Conference_Id} color={conferenceLocation} options={options} />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

NewsletterSignUpSection.propTypes = {
  conference: PropTypes.object.isRequired,
  conferenceLocation: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
}

export default NewsletterSignUpSection
